<template>
    <div id="contract-block" class="content-block">
        <div class="filter-layer">
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="72px" label-position="left">
                <el-form-item label="合同名称" prop="taskName">
                    <el-input v-model="queryParams.taskName" placeholder="请输入合同名称" clearable size="small"
                        @keyup.enter.native="handleQuery" />
                </el-form-item>
                <el-form-item label="发起时间">
                    <el-date-picker v-model="queryParams.dateRange" size="small" style="width: 240px"
                        value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期"
                        end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="发起方" prop="initiatorName">
                    <el-input v-model="queryParams.initiatorName" placeholder="请输入发起方名称" clearable size="small"
                        @keyup.enter.native="handleQuery" />
                </el-form-item>
                <el-form-item label="签署方" prop="signerName">
                    <el-input v-model="queryParams.signerName" placeholder="请输入签署方名称" clearable size="small"
                        @keyup.enter.native="handleQuery" />
                </el-form-item>
                <el-form-item label="合同类型" prop="taskType">
                    <el-select v-model="queryParams.taskType" placeholder="请选择合同类型" size="small">
                        <el-option label="全部" value="all">
                        </el-option>
                        <el-option label="普通合同" value="normal">
                        </el-option>
                        <el-option label="作废合同" value="relieve">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="margin-right: 16px;">
                    <el-button size="small" class="grey-btn" @click="handleResetForm"
                        :disabled="calcQueryParamsDisable()"><svg-icon iconClass="icon-refresh"
                            style="width: 16px;height: 16px;" />重置</el-button>
                </el-form-item>
                <el-form-item style="margin-right: 16px;">
                    <el-button type="primary" size="small" @click="handleQuery"><svg-icon iconClass="icon-search"
                            style="width: 16px;height: 16px;" />查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" class="grey-btn" :disabled="!tableList.length" @click="handleExport"><svg-icon
                            iconClass="icon-export" style="width: 16px;height: 16px;" />导出合同</el-button>
                </el-form-item>
                <!-- tableSelectionTaskIds.length -->
                <div class="stand-btn-float-wrap">
                    <div v-if="['waitSend', 'iSign'].includes($route.query.status)" class="flex-center stand-btn-wrap"
                        :class="{ 'show-tip': tableSelectionTaskIds.length }">
                        <span class="table-selection-tip">已选{{
                            tableSelectionTaskIds.length }}条<span style="display: inline-block;width: 20px;"></span></span>
                        <el-tooltip effect="dark" :content="batchOperationTipContent" placement="right"
                            v-model="batchOperationTipShow" :manual="true">
                            <el-button type="primary" size="small" @click="batchOperation($route.query.status)"
                                class="stand-btn">
                                <span v-if="$route.query.status === 'waitSend'">
                                    <svg-icon iconClass="icon-launch-deliver"
                                        style="width: 16px;height: 16px;margin-top: -2px;" />
                                    批量发送
                                </span>
                                <span v-if="$route.query.status === 'iSign'">
                                    <svg-icon iconClass="icon-batch-sign" style="width: 16px;height: 16px;" />
                                    批量签署
                                </span>
                            </el-button>
                        </el-tooltip>

                    </div>
                </div>

            </el-form>
        </div>
        <div class="table-layer">
            <el-table ref="listTableRef" :data="tableList" @selection-change="handleSelectionChange($event, '1')"
                :header-cell-style="{ background: '#F2F3F5', color: '#1D2129', fontWeight: 500, padding: '12px 10px' }"
                :cell-style="{
                    color: '#313843',
                    fontWeight: 400,
                    padding: '12px 10px'
                }" height="100%">
                <el-empty description="暂无数据" slot="empty" :image="require('@/assets/images/home/default.png')"
                    :image-size="220">
                </el-empty>
                <el-table-column v-if="['waitSend', 'iSign'].includes($route.query.status)" type="selection" width="38"
                    align="left" class-name="selection-column">
                </el-table-column>
                <el-table-column prop="taskName" label="合同名称" width="110" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="合同状态" width="100">
                    <template slot-scope="scope">
                        <div class="flex-center">
                            <span class="dot" :style="{ background: computeScopeRowItem(scope.row.status).bg }"></span>
                            <span>{{ computeScopeRowItem(scope.row.status).statusTxt }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="initiatorName" label="发起人/企业" width="123" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="signerName" label="签署人/企业" width="123" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="taskType" label="合同类型" width="94">
                    <template slot-scope="scope">
                        <div class="scope-content">
                            <span v-if="scope.row.taskType == 'normal'">普通合同</span>
                            <span v-if="scope.row.taskType == 'relieve'">作废合同</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="signStartTime" label="发起时间" width="130" />
                <el-table-column prop="signExpireTime" label="截止时间" width="130" />
                <el-table-column label="操作" fixed="right" width="140">
                    <template slot-scope="scope">
                        <el-button type="text"
                            @click="toContractInfo(scope.row.signId, scope.row.taskType, scope.row.taskId)">查看</el-button>
                        <el-button type="text" v-show="scope.row.status == 'waitSend'"
                            @click="updateTaskStatus2Send(scope.row)">发送</el-button>
                        <el-button type="text" v-show="scope.row.status == 'finish' || scope.row.status == 'cancel'"
                            @click="toDownload(scope.row)">下载
                        </el-button>
                        <!-- <el-button type="text" style="margin-left:10px;"  v-show="scope.row.status == 'finish'" @click="toDownloadEvidence(scope.row)">下载签署报告</el-button> -->
                        <el-button type="text" v-show="scope.row.status == 'draft'"
                            @click="toEdit(scope.row)">编辑</el-button>
                        <el-button type="text" v-show="
                            scope.row.status == 'iSign' ||
                            scope.row.status == 'signingApprovalFailed'
                        " @click="toSign(scope.row)">签署</el-button>
                        <el-button type="text" class="grey"
                            v-show="scope.row.status == 'otherSign' && scope.row.initiateUser == 'yes'"
                            @click="toRecall(scope.row.signId)">撤回</el-button>
                        <!-- <el-button type="text" class="grey" v-show="scope.row.status == 'process'"
                            @click="recallApproveHandle(scope.row.signId)">撤回</el-button> -->
                        <el-button type="text" class="grey" v-show="
                            scope.row.status == 'iSign' ||
                            scope.row.status == 'signingApprovalFailed'
                        " @click="rejectContractHandle(scope.row.signId)">拒签</el-button>
                        <el-button type="text" class="grey"
                            v-show="scope.row.status == 'finish' && scope.row.taskType != 'relieve' && scope.row.initiateUser == 'yes'"
                            @click="relieveContractHandle(scope.row)">作废</el-button>
                        <!-- <el-button style="margin-left:10px;" type="text"  v-show="scope.row.status == 'pendTrial'" @click="pendTrialHandle(scope.row.signId)">送审</el-button> -->
                        <el-button type="text" class="danger" v-show="
                            scope.row.status == 'pendTrial' ||
                            scope.row.status == 'waitSend' ||
                            scope.row.status == 'expire' ||
                            scope.row.status == 'draft'
                        " @click="toDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <transition name="el-zoom-in-bottom">
                <span class="top-btn" v-show="topBtnShow" @click="handleListTable2Top"></span>
            </transition>


        </div>
        <div class="pager-layer">
            <el-pagination size="small" :total="total" :current-page="queryParams.pageNum"
                layout="sizes, total, prev, pager, next " :page-sizes="[5, 10, 20, 100]" :page-size="queryParams.pageSize"
                @size-change="sizeChange" @current-change="pageChange" />
        </div>













        <!--    <el-dialog title="请选择签章" :visible.sync="showSignature" :center="true" width="700px" append-to-body :close-on-click-modal="false">-->
        <!--      <span>这是一段信息</span>-->
        <!--      <span slot="footer" class="dialog-footer">-->
        <!--        <el-button @click="dialogVisible = false">取消签署</el-button>-->
        <!--        <el-button type="primary" @click="dialogVisible = false">确认签署</el-button>-->
        <!--      </span>-->
        <!--    </el-dialog>-->
        <el-drawer title="合同批量签署" :visible.sync="showSignature" :show-close="false" :wrapperClosable="false"
            :append-to-body="true" size="50%" direction="rtl">
            <div style="width: 100%;display: flex;align-items: center;justify-content: space-between;" slot="title">
                合同批量签署
                <div>
                    <!--          <el-popconfirm-->
                    <!--              title="批量签署过程中，关闭窗口会导致剩余合同签署失败！！！"-->
                    <!--              confirm-button-type="text"-->
                    <!--              @confirm="upload(1)"-->
                    <!--          >-->
                    <el-button size="small" type="primary" @click="upload(1)" :disabled="upStatus !== 0">
                        <i v-if="upStatus === 2" style="color: #fff" class="el-icon-circle-check"></i>
                        <i v-if="upStatus === 1" style="color: #fff" class="el-icon-loading"></i>
                        {{ upStatus === 0 ? '确认签署' : upStatus === 1 ? tableUpStatus : '签署完成' }}
                    </el-button>
                    <!--          tableSelectionTaskIds.filter(item=>item.upStatus === 2).length+'/'+tableSelectionTaskIds.length-->
                    <!--          </el-popconfirm>-->
                    <el-button size="small" @click="closeD">关闭</el-button>
                </div>



            </div>
            <el-form label-position="top" label-width="80px" style="padding: 0 20px">
                <el-form-item>
                    <p slot="label">
                        已授权签章 <span style="color: red;">（可多选）</span>
                        <el-button size="mini" class="button" @click="selectSing()"
                            :disabled="upStatus !== 0">重置</el-button>
                    </p>
                    <el-row :gutter="10">
                        <template v-for="(item, index) in BatchSignSeal">
                            <el-col :gutter="10" :span="6"
                                v-if="(item.sealType === 'companyCommon' && item.permissionType === 'authed') || item.sealType === 'person' || item.sealType === 'companyAgent' || item.sealType === 'date' || (item.sealType === 'companyLegal' && item.permissionType === 'authed')"
                                :key="index" style="margin-bottom: 10px;height: 230px">
                                <el-card shadow="hover" :body-style="{ padding: '10px', height: '100%' }">
                                    <img class="signImage" :src="item.sealImg" style="max-width: 80%; margin: 0 auto;">
                                    <div class="signTitle">
                                        <p>{{ item.sealName }}</p>
                                        <el-button type="text" class="button" @click="selectSing(item)"
                                            :disabled="upStatus !== 0 || selectSingData.includes(item.sealId)">
                                            {{ selectSingData.includes(item.sealId) ? '已选择' : '未选择' }}</el-button>
                                    </div>
                                </el-card>
                            </el-col>
                        </template>

                    </el-row>
                </el-form-item>
                <el-form-item>
                    <p slot="label">
                        未授权签章 <span style="color: red;">禁止选择</span>
                    </p>
                    <el-row :gutter="10">
                        <template v-for="(item, index) in BatchSignSeal">
                            <el-col :gutter="10" :span="6" v-if="item.permissionType === 'process'" :key="index"
                                style="margin-bottom: 10px">
                                <el-card shadow="hover" :body-style="{ padding: '10px' }">
                                    <img class="signImage" :src="item.sealImg">
                                    <div class="signTitle">
                                        <p>{{ item.sealName }}</p>
                                    </div>
                                </el-card>
                            </el-col>
                        </template>

                    </el-row>
                </el-form-item>
                <!--        <el-form-item>-->
                <!--          <p slot="label">-->
                <!--            已授权日期 <span style="color: red;">（已选择）</span>-->
                <!--          </p>-->
                <!--          <el-row :gutter="12">-->

                <!--            <el-col :span="6" v-for="(o, index) in 7" :key="o" style="margin-bottom: 10px">-->
                <!--              <el-card shadow="hover">-->
                <!--                  <img class="signImage" src="http://8.131.51.198:8010/restful/api/common/v1/tool/downSealImg?sealId=currentDateSealId&ctime=1676858169906">-->
                <!--                  <el-button type="text" class="button">选择</el-button>-->
                <!--              </el-card>-->
                <!--            </el-col>-->

                <!--          </el-row>-->
                <!--        </el-form-item>-->
                <el-form-item>
                    <p slot="label">
                        待签署合同
                    </p>
                    <el-table :data="tableSelectionTaskIds" :key="updateKey" style="width: 100%">
                        <el-table-column label="序号" width="80">
                            <template slot-scope="scope">
                                {{ scope.row.index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="taskName" label="合同名称" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="errMsg" label="提示" show-overflow-tooltip>
                            <template slot-scope="scope">

                                <div class="scope-content" v-if="scope.row.upStatus === 2" style="color: #31bf77">
                                    {{ scope.row.errMsg
                                    }}
                                </div>
                                <div class="scope-content" v-if="scope.row.upStatus === 3" style="color: red">
                                    {{ scope.row.errMsg
                                    }}
                                </div>

                            </template>
                        </el-table-column>
                        <el-table-column prop="address" width="80" label="状态">
                            <template slot-scope="scope">
                                <p style="font-size: 20px">
                                    <i v-if="scope.row.upStatus === 1" class="el-icon-loading"></i>
                                    <i v-if="scope.row.upStatus === 2" style="color: #30bf77"
                                        class="el-icon-circle-check"></i>
                                    <i v-if="scope.row.upStatus === 0" class="el-icon-time"></i>
                                    <i v-if="scope.row.upStatus === 3" style="color: red" class="el-icon-circle-close"></i>
                                </p>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <!--        <el-form-item>-->
                <!--          <p slot="label">-->
                <!--            签署成功-->
                <!--          </p>-->
                <!--          <el-table-->
                <!--              :data="data"-->
                <!--              style="width: 100%">-->
                <!--            <el-table-column-->
                <!--                align="center"-->
                <!--                label="序号"-->
                <!--                width="80">-->
                <!--              <template slot-scope="scope">-->
                <!--                {{scope.$index+1}}-->
                <!--              </template>-->
                <!--            </el-table-column>-->
                <!--            <el-table-column prop="taskName" label="合同名称" align="left">-->
                <!--              <template slot-scope="scope">-->
                <!--                <el-tooltip :content="scope.row.taskName" placement="top" effect="light">-->
                <!--                  <div class="scope-content">-->
                <!--                    <span>{{ scope.row.taskName }}</span>-->
                <!--                  </div>-->
                <!--                </el-tooltip>-->
                <!--              </template>-->
                <!--            </el-table-column>-->
                <!--            <el-table-column-->
                <!--                prop="address"-->
                <!--                align="center"-->
                <!--                width="80"-->
                <!--                label="状态">-->
                <!--              <template slot-scope="scope">-->
                <!--                <p style="font-size: 20px">-->
                <!--                  &lt;!&ndash;                  <i  class="el-icon-loading"></i>&ndash;&gt;-->
                <!--                  <i style="color: #30bf77" class="el-icon-circle-check"></i>-->
                <!--                  &lt;!&ndash;                  <i class="el-icon-time"></i>&ndash;&gt;-->
                <!--                </p>-->
                <!--              </template>-->
                <!--            </el-table-column>-->
                <!--          </el-table>-->
                <!--        </el-form-item>-->
            </el-form>
        </el-drawer>
        <sign-auth ref="auth" @getAuthCode="upload(2, $event)" @cancel="cancel"></sign-auth>
    </div>
</template>
<script>
import signAuth from "@/views/sign/sign-auth";
import {
    // getTaskList,
    updateTaskStatus2Send,
    updateTaskStatus2Delete,
    updateTaskStatus2Reject,
    contractCountApi,
    downloadContractEvidenceApi,
    downloadContractApi,
    deleteContractApi,
    sendContractApi,
    recallContractApi,
    returnContractApi,
    sendApproveApi,
    recallApproveApi,
    downloadContracExcelApi,
    taskList,
    signBeforeCheck,
    updateBatchTaskStatus2Send,
    getBatchSignSealInfo,
    signBatchProcessPosition, getSpaceDetailInfo
} from "@/api/space/contracts";
import {
    getRelieveInfo
} from "@/api/sign/sign";
import { getContractImgsApi, getContractSignStatusApi } from "@/api/sign/flow";
import { getToken } from "@/utils/auth";
import { parseTime, downloadFile } from "@/utils/index";
import { mapState } from "vuex";
export default {
    data() {
        return {
            dialogVisible: false,
            sealId: "",
            lastFlag: "",
            queryParams: {
                pageNum: "",
                pageSize: "",
                status: "",
                taskName: "",
                initiatorName: "",
                signerName: "",
                dateRange: "",
                taskType: "all"
            },
            total: 0,
            tableList: [],
            loading: false,
            tableSelectionTaskIds: [],//存放批量选择的id
            showSignature: false,//显示签名弹窗
            BatchSignSeal: [],
            positionSeal: {
                companyCommon: '',//	非必填	string	企业公章
                companyLegal: '',//	非必填	string	企业法定代表人章
                companyAgent: '',//	非必填	string	企业经办人个人章
                person: '',//	非必填	string	个人手写章
                date: '',//	非必填	string	日期章
            },
            selectSingData: [],
            upStatus: 0,
            updateKey: 0,

            topBtnShow: false,
            batchOperationTipShow: false,
            batchOperationTipContent: ""
        }
    },
    components: {
        signAuth,
    },
    computed: {
        tableUpStatus() {
            return this.tableSelectionTaskIds.filter(item => item.upStatus === 2).length + '/' + this.tableSelectionTaskIds.length
        },
        ...mapState(["companyList", "currentSpace", "userInfo", "contractSift"])
    },
    watch: {
        //监听路由地址的改变
        $route: {
            immediate: true,
            handler() {
                this.initUserContracts();
            }
        }
    },
    created() {
    },
    mounted() {
        window
            .addEventListener("scroll", (e) => {
                if (this.$refs.listTableRef) {
                    let target = this.$refs.listTableRef.$el.querySelector(".el-table__body-wrapper");
                    e.preventDefault();
                    // e.stopPropagation();
                    if (target.scrollTop > 100) {
                        this.topBtnShow = true;
                    } else {
                        this.topBtnShow = false;
                    }
                }
            }, true)
        window.addEventListener("resize", this.resiezeListTableRefEventHandler, true)
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resiezeListTableRefEventHandler, true)
    },
    methods: {
        resiezeListTableRefEventHandler() {
            if (this.$refs.listTableRef) {
                this.$refs.listTableRef.doLayout();
                document.querySelector(".el-table .el-table__fixed-right").style.maxHeight = 46 * (this.tableList.length + 1) + 'px';
                document.querySelector(".el-table .el-table__fixed-right").style['box-shadow'] = '-2px 0px 2px 0px rgba(0,0,0,0.1)';
                document.querySelector(".table-layer").style.height = document.getElementById("contract-block").offsetHeight - document.querySelector(".filter-layer").offsetHeight - 32 - 20 - 60 + "px";
            }
        },
        calcQueryParamsDisable() {
            let { startSignTime, endSignTime, initiatorName, signerName, taskName, taskType } = this.queryParams;
            if (!startSignTime && !endSignTime && !initiatorName && !signerName && !taskName && (taskType == "all" || taskType == "")) {
                return true;
            } else {
                return false
            }
        },
        computeScopeRowItem(rowStatus) {
            let ret = {};
            switch (rowStatus) {
                case "waitSend":
                    ret = {
                        bg: "#00D4CD",
                        statusTxt: "待发送"
                    }
                    break;
                case "iSign":
                    ret = {
                        bg: "#448DF7",
                        statusTxt: "待我签署"
                    }
                    break;
                case "otherSign":
                    ret = {
                        bg: "#8A34FA",
                        statusTxt: "待他签署"
                    }
                    break;
                case "process":
                    ret = {
                        bg: "#EA8B56",
                        statusTxt: "审批中"
                    }
                    break;
                case "finish":
                    ret = {
                        bg: "#00B42A",
                        statusTxt: "签署完成"
                    }
                    break;
                case "reject":
                    ret = {
                        bg: "#EC5B56",
                        statusTxt: "已拒签"
                    }
                    break;
                case "recall":
                    ret = {
                        bg: "#CCCCCC",
                        statusTxt: "已撤回"
                    }
                    break;
                case "expire":
                    ret = {
                        bg: "#CCCCCC",
                        statusTxt: "已过期"
                    }
                    break;
                case "cancel":
                    ret = {
                        bg: "#CCCCCC",
                        statusTxt: "已作废"
                    }
                    break;
                default:
                    ret = {
                        bg: "#EFB040",
                        statusTxt: "草稿箱"
                    }

            }

            return ret;
        },
        handleListTable2Top() {
            this.$refs.listTableRef.$el.querySelector(".el-table__body-wrapper").scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
        },
        initUserContracts() {
            this.queryParams = {
                pageNum: this.$route.query.pageNum ? Number(this.$route.query.pageNum) : 1,
                pageSize: this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 10,
                taskName: this.$route.query.taskName ? this.$route.query.taskName : undefined,
                dateRange: this.$route.query.startSignTime ? [this.$route.query.startSignTime, this.$route.query.endSignTime] : undefined,
                startSignTime: this.$route.query.startSignTime || undefined,
                endSignTime: this.$route.query.endSignTime || undefined,
                initiatorName: this.$route.query.initiatorName || undefined,
                signerName: this.$route.query.signerName || undefined,
                taskType: this.$route.query.taskType || "all",
                companyId: this.currentSpace.companyId || "",
                status: this.$route.query.status || "all",
            }
            let queryParams = Object.assign({}, this.queryParams);
            queryParams.taskType == "all" && (queryParams.taskType = "");
            // console.log(queryParams)
            this.loading = true
            taskList(queryParams).then(res => {
                if (res.code != 200) {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: 'warning'
                    });
                } else {
                    this.loading = false
                    this.total = res.data.total
                    this.tableList = res.data.taskInfoArray
                    // 动态修改el-table样式

                    document.querySelector(".el-table .el-table__fixed-right").style.maxHeight = 46 * (this.tableList.length + 1) + 'px';
                    document.querySelector(".el-table .el-table__fixed-right").style['box-shadow'] = '-2px 0px 2px 0px rgba(0,0,0,0.1)';
                    document.querySelector(".table-layer").style.height = document.getElementById("contract-block").offsetHeight - document.querySelector(".filter-layer").offsetHeight - 32 - 20 - 60 + "px";

                }
            }).catch(err => {
                this.loading = false
            })
        },

        handleResetForm() {
            this.queryParams = Object.assign({}, this.queryParams, {
                pageNum: 1,
                taskName: "",
                initiatorName: "",
                signerName: "",
                dateRange: "",
                taskType: "all"
            })
            this.$refs["queryForm"].resetFields();
            this.handleQuery();
        },

        pageChange(e) {
            this.queryParams.pageNum = e
            this.handleQuery()
        },
        sizeChange(e) {
            this.queryParams.pageNum = 1
            this.queryParams.pageSize = e
            this.handleQuery()
        },



        getUserInfoHandle() {
            contractCountApi()
                .then((res) => {
                    if (res.code !== 200) {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "warning",
                        });
                    } else {
                        this.$store.commit("SET_USER_CONTRSCT_INFO", res.data);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // beforeInit() {
        //   // console.log(this.queryParams.dateRange);
        //   this.url = "/api/common/v1/task/list";
        //   var startSignTime = this.queryParams.dateRange
        //     ? this.queryParams.dateRange[0]
        //     : "";
        //   var endSignTime = this.queryParams.dateRange
        //     ? this.queryParams.dateRange[1]
        //     : "";
        //   if (this.lastFlag != this.$route.query.status) {
        //     this.page = 1;
        //     // this.size = 5;
        //   }
        //   this.lastFlag = this.$route.query.status;
        //   this.params = {
        //     pageNum: this.page > 0 ? this.page : 1,
        //     pageSize: this.size,
        //     companyId: this.currentSpace.companyId || "",
        //     status: this.$route.query.status,
        //     taskName: this.queryParams.taskName,
        //     startSignTime: startSignTime,
        //     endSignTime: endSignTime,
        //     initiatorName: this.queryParams.initiatorName,
        //     signerName: this.queryParams.signerName,
        //     taskType: this.queryParams.taskType
        //   };
        //   return true;
        // },
        handleQuery() {
            let queryParams = Object.assign({}, this.queryParams, {
                startSignTime: this.queryParams.dateRange ? this.queryParams.dateRange[0] : undefined,
                endSignTime: this.queryParams.dateRange ? this.queryParams.dateRange[1] : undefined,
            });
            let queryParamsShorted = {};
            Object.keys(this.queryParams).forEach(key => {
                if (queryParams[key]) {
                    queryParamsShorted[key] = queryParams[key];
                }
            })
            this.$router.push({
                url: "/user-space/contracts",
                query: queryParamsShorted
            })
            // this.init();
        },

        toContractInfo(signId, taskType, taskId) {
            // this.$store.commit("SET_CONTRACTSIFT", this.params);
            this.$router.push({
                path: "/temp-info",
                query: {
                    signId,
                    taskType,
                    taskId
                },
            });
        },
        updateTaskStatus2Send(info) {
            this.$confirm("确定要发送吗？", "温馨提示", {
                confirmButtonText: "发送",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateTaskStatus2Send({ signId: info.signId })
                        .then((res) => {
                            if (res.code !== 200) {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "warning",
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: "发送成功！",
                                    type: "success",
                                });
                                this.initUserContracts();
                                this.getUserInfoHandle();
                                this.$parent.handleGetSpaceDetailInfo();
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch(() => { });
        },

        // sendContract(info) {
        // 	this.$router.push({
        // 		path: "/flow",
        // 		query: {
        // 			contractId: info.contractId
        // 		}
        // 	});
        // },
        pendTrialHandle(contractId) {
            sendApproveApi({
                contractId: contractId,
                nocache: new Date().getTime(),
            })
                .then((res) => {
                    if (res.code !== 200) {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "warning",
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: "送审成功！",
                            type: "success",
                        });

                        this.initUserContracts();
                        this.getUserInfoHandle();
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        toEdit(info) {
            this.$router.push({
                path: "/temp-create",
                query: {
                    taskId: info.taskId,
                },
            });
            // if (info.status == 1) {
            //   var names = info.names.split(',');
            //   var isFirst = 'true'
            //   if (names[0] == this.userInfo.name) {
            //     isFirst = 'true'
            //   } else {
            //     isFirst = 'false'
            //   }

            //   this.$router.push({
            //     path: '/set-control',
            //     query: {
            //       contractId: info.contractId,
            //       isFirst: isFirst,
            //       isSame: true
            //     }
            //   })
            // } else if (info.status == 0) {
            //   this.$router.push({
            //     path: '/flow',
            //     query: {
            //       contractId: info.contractId
            //     }
            //   })
            // }
        },
        toDownload(info) {
            downloadContractApi({
                signId: info.signId,
            })
                .then((res) => {
                    downloadFile(res, info.taskName, "zip");
                })
                .catch((err) => {
                    console.log(err);
                });
            // window.location.href = ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API)? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API)+'/contract/download?contractId='+contractId
        },
        handleExport() {
            let startSignTime = this.queryParams.dateRange
                ? this.queryParams.dateRange[0]
                : "";
            let endSignTime = this.queryParams.dateRange
                ? this.queryParams.dateRange[1]
                : "";
            let params = {
                status: this.$route.query.status,
                taskName: this.queryParams.taskName,
                startSignTime: startSignTime,
                endSignTime: endSignTime,
                initiatorName: this.queryParams.initiatorName,
                signerName: this.queryParams.signerName,
            };

            downloadContracExcelApi(params)
                .then((res) => {
                    downloadFile(res, "合同列表", "xlsx");
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // toDownloadEvidence(info) {
        // 	downloadContractEvidenceApi(info.contractId)
        // 		.then(res => {
        // 			downloadFile(res, info.taskName + "_签署报告", "pdf");
        // 		})
        // 		.catch(err => {
        // 			console.log(err);
        // 		});
        // 	// window.location.href = ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API)? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API)+'/contract/download?contractId='+contractId
        // },
        toDelete(info) {
            this.$confirm("确定要删除吗？", "温馨提示", {
                confirmButtonText: "删除",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateTaskStatus2Delete({ signId: info.signId })
                        .then((res) => {
                            if (res.code !== 200) {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "warning",
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: "删除成功！",
                                    type: "success",
                                });

                                this.initUserContracts();
                                this.getUserInfoHandle();
                                // setTimeout(() => {
                                // 	location.reload();
                                // }, 200);
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch(() => { });
        },
        relieveContractHandle(info) {
            this.$confirm("确定要作废该合同吗？", "温馨提示", {
                confirmButtonText: "作废",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    getRelieveInfo({
                        signId: info.signId,
                    }).then((res) => {
                        if (res.code !== 200) {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "warning",
                            });
                        } else {
                            this.$router.push({
                                path: "/launchtask",
                                query: {
                                    signId: info.signId,
                                },
                            });
                        }
                    })
                })
                .catch(() => { });
        },
        rejectContractHandle(signId) {
            this.$confirm("确定要拒签该合同吗？", "温馨提示", {
                confirmButtonText: "拒签",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateTaskStatus2Reject({
                        signId: signId,
                    })
                        .then((res) => {
                            console.log(res);
                            if (res.code !== 200) {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "warning",
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: "拒签成功！",
                                    type: "success",
                                });

                                this.initUserContracts();
                                this.getUserInfoHandle();
                                // setTimeout(() => {
                                // 	location.reload();
                                // }, 200);
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch(() => { });
        },

        toRecall(signId) {
            this.$confirm("确定要撤回该合同吗？", "温馨提示", {
                confirmButtonText: "撤回",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    recallContractApi({
                        signId: signId,
                    })
                        .then((res) => {
                            if (res.code !== 200) {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "warning",
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: "撤回成功！",
                                    type: "success",
                                });

                                this.initUserContracts();
                                this.getUserInfoHandle();
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch(() => { });
        },
        recallApproveHandle(contractId) {
            this.$confirm("确定要撤回该审批吗？", "温馨提示", {
                confirmButtonText: "撤回",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    recallApproveApi({
                        contractId: contractId,
                        nocache: new Date().getTime(),
                    })
                        .then((res) => {
                            if (res.code !== 200) {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "warning",
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: "撤回成功！",
                                    type: "success",
                                });

                                this.initUserContracts();
                                this.getUserInfoHandle();
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch(() => { });
        },
        toSign(info) {
            // if (this.userInfo.name != info.signUserName) {
            //   this.$message({
            //     showClose: true,
            //     message: '当前签署人与指定签署人不一致！',
            //     type: 'warning'
            //   });

            //   return;
            // }

            signBeforeCheck({
                signId: info.signId
            }).then(res => {
                if (res.code == 200) {
                    if (res.data.signBeforeCheck) {
                        this.$router.push({
                            path: "/signing",
                            query: {
                                signId: info.signId,
                                signType: this.currentSpace.companyId ? "1" : "0",
                                companyId: this.currentSpace.companyId,
                            },
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.signBeforeCheckInfo,
                            type: "warning"
                        });
                    }

                } else {

                }
            })



        },
        // showContractImgList(info) {
        // 	getSignFileImgArray({
        // 		signFileId: info.signId
        // 	})
        // 		.then(res => {
        // 			console.log(res);
        // 			if (res.code !== 200) {
        // 				this.$message({
        // 					showClose: true,
        // 					message: res.message,
        // 					type: "warning"
        // 				});
        // 			} else {
        // 				this.pngList = res.data.pngList.map(el => {
        // 					console.log(el);
        // 					console.log(getToken());
        // 					return (
        // 						process.env.VUE_APP_BASE_API +
        // 						el +
        // 						getToken() +
        // 						"&r=" +
        // 						new Date().getTime()
        // 					);
        // 				});

        // 				this.dialogVisible = true;
        // 			}
        // 		})
        // 		.catch(err => {
        // 			console.log(err);
        // 		});
        // }
        handleSelectionChange(e, type) {
            if (this.upStatus === 2) return
            this.tableSelectionTaskIds = JSON.parse(JSON.stringify(e.map((item, index) => {
                item.index = index;
                item.upStatus = 0;
                return item
            })))
        },
        batchOperation(stats) {
            if (!this.tableSelectionTaskIds.length) {
                this.batchOperationTipContent = stats == 'waitSend' ? "请先勾选要批量发送的合同" : "请先勾选要批量签署的合同";
                this.batchOperationTipShow = true;
                setTimeout(() => {
                    this.batchOperationTipShow = false;
                }, 1000)
                return;
            }
            if (this.$route.query.status === 'iSign') {
                this.showSignature = true;
                this.selectSingData = [];
                this.upStatus = 0
                this.positionSeal = {
                    companyCommon: '',//	非必填	string	企业公章
                    companyLegal: '',//	非必填	string	企业法定代表人章
                    companyAgent: '',//	非必填	string	企业经办人个人章
                    person: '',//	非必填	string	个人手写章
                    date: '',//	非必填	string	日期章
                }
                getBatchSignSealInfo().then(({ code, data: { sealInfoArray } }) => {
                    this.BatchSignSeal = sealInfoArray
                })
            } else if (this.$route.query.status === 'waitSend') {
                //   发送
                this.$confirm("确定要批量发送吗？", "温馨提示", {
                    confirmButtonText: "发送",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateBatchTaskStatus2Send({
                            signIds: this.tableSelectionTaskIds.map(item => item.signId)
                        }).then((res) => {
                            console.log(res)
                            this.$message.success('批量发送成功！');
                            this.initUserContracts();
                            this.getUserInfoHandle();
                            this.$parent.handleGetSpaceDetailInfo();
                        })
                    })
            }
        },
        selectSing(item) {
            if (!item) {
                this.selectSingData = [];
                this.positionSeal = {
                    companyCommon: '',//	非必填	string	企业公章
                    companyLegal: '',//	非必填	string	企业法定代表人章
                    companyAgent: '',//	非必填	string	企业经办人个人章
                    person: '',//	非必填	string	个人手写章
                    date: '',//	非必填	string	日期章
                }
                return;
            }
            if (!this.positionSeal[item.sealType] && !this.selectSingData.includes(item.sealId)) {
                this.selectSingData.push(item.sealId);
            } else {
                this.selectSingData.splice(this.selectSingData.indexOf(this.positionSeal[item.sealType]), 1, item.sealId)
            }
            this.positionSeal[item.sealType] = item.sealId;
        },
        upload(type, event) {
            if (type === 1) {
                getSpaceDetailInfo().then(({ code, data }) => {
                    if (code === 200) {
                        // 经办人类型（企业章必选、法定代表非必选、经办人非必选）
                        if (data.spaceType === 'company' && this.$store.state.userInfo.userType === 'person') {
                            if (this.positionSeal.companyCommon) {
                                if (!this.positionSeal.companyAgent && !this.positionSeal.companyLegal) {
                                    this.$message.warning('您未选择【法定代表人印章】和【经办人印章】，可能会导致需要加盖此类型印章的合同，签署失败！');
                                }
                                else if (!this.positionSeal.companyAgent) {
                                    this.$message.warning('您未选择【经办人印章】，可能会导致需要加盖此类型印章的合同签署失败！');

                                }
                                else if (!this.positionSeal.companyLegal) {
                                    this.$message.warning('您未选择【法定代表人印章】，可能会导致需要加盖此类型印章的合同签署失败！');
                                }
                                this.upload(3);
                            }
                            else {
                                this.$message.warning('请选择企业印章！');
                            }
                        }
                        //个人章（个人章必选）
                        else if (data.spaceType === 'person' && this.$store.state.userInfo.userType === 'person') {
                            if (this.positionSeal.person) {
                                this.upload(3);
                            } else {
                                this.$message.warning('请选择个人印章！');
                            }
                        }
                        //企业（企业章必选、法定代表非必选）
                        else if (data.spaceType === 'company' && this.$store.state.userInfo.userType === 'company') {
                            if (this.positionSeal.companyCommon) {
                                if (!this.positionSeal.companyLegal) {
                                    this.$message.warning('您未选择【法定代表人印章】，可能会导致需要加盖此类型印章的合同签署失败！');
                                }
                                this.upload(3);
                            } else {
                                this.$message.warning('请选择企业印章！');
                            }
                        }
                    }
                })
            }
            if (type === 3) {
                this.$refs.auth.dialogVisible = true;
            }
            if (type === 2) {
                this.upStatus = 1;
                this.cb(0, event.signAuthToken)
            }

        },
        cb(index, signAuthToken) {
            if (this.tableSelectionTaskIds[index]) this.tableSelectionTaskIds[index].upStatus = 1;
            signBatchProcessPosition({
                signId: this.tableSelectionTaskIds[index].signId,
                positionSeal: this.positionSeal,
                signAuthToken
            }).then(({ code, data }) => {
                this.updateKey += 1;
                if (code === 200) {
                    this.tableSelectionTaskIds[index].upStatus = 2;
                    this.tableSelectionTaskIds[index].errMsg = '签署成功';
                } else {
                    this.tableSelectionTaskIds[index].upStatus = 3;
                    this.tableSelectionTaskIds[index].errMsg = data;
                }
                if (this.tableSelectionTaskIds[index + 1]) {
                    this.cb(index + 1, signAuthToken)
                }
                else {
                    this.upStatus = 2;
                    this.initUserContracts();
                    this.getUserInfoHandle();
                    this.$parent.handleGetSpaceDetailInfo();
                }
            })
        },
        cancel() {
            // this.dialogVisible = false;
        },
        closeD() {
            this.showSignature = false;
            this.selectSingData = [];
            this.tableSelectionTaskIds = [];
            this.upStatus = 0;
            this.positionSeal = {
                companyCommon: '',//	非必填	string	企业公章
                companyLegal: '',//	非必填	string	企业法定代表人章
                companyAgent: '',//	非必填	string	企业经办人个人章
                person: '',//	非必填	string	个人手写章
                date: '',//	非必填	string	日期章
            }
            this.initUserContracts();
            this.getUserInfoHandle();
            this.$parent.handleGetSpaceDetailInfo();

        }

    },
}
</script>
<style lang="scss" scoped>
.content-block {
    padding: 32px 0 0 20px;
    position: relative;
    height: 100%;
}

.filter-layer {
    .el-button /deep/ span {
        display: flex;
        align-items: center;

        .svg-icon {
            margin-right: 7px;
        }
    }
}

.pager-layer {
    width: 100%;
    height: 60px;
    padding-right: 20px;
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background: #fff;
    z-index: 99;

    .el-form-item {
        margin-right: 24px;
        margin-bottom: 16px;
        height: 32px;
        line-height: 32px;
    }
}

.el-form-item {
    // /deep/ .el-form-item__label {
    //     font-size: 14px;
    //     font-weight: 400;
    //     color: #4E5969;
    // }

    // &+.el-form-item {
    //     // margin-left: 24px;


    // }

    .el-button {
        min-width: 84px;
    }
}

.el-input {
    height: 32px;
    line-height: 32px;

    /deep/ .el-input__inner {
        width: 240px;
    }
}

.el-select {
    /deep/ .el-input__inner {
        // width: 240px;
        width: 240px;
    }
}

.stand-btn-float-wrap {
    overflow: hidden;

    .stand-btn-wrap {
        margin-top: 8px;
        float: left;

        &.show-tip {
            .table-selection-tip {
                width: calc(100%);
                opacity: 1;
                transition-property: width;
                transition-duration: .4s;
                transition-timing-function: ease;
            }
        }

        .table-selection-tip {
            width: 0;
            font-size: 12px;
            font-weight: 400;
            color: #1D2129;
            display: inline-block;
            opacity: 0;
            white-space: nowrap;
        }
    }
}

.table-layer {
    margin-top: 20px;
    height: auto;
    padding-right: 20px;

    .top-btn {
        display: block;
        width: 60px;
        height: 60px;
        background: url(../../assets/icons/png/icon-top.png) center no-repeat;
        background-size: 100%;
        // box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.1);
        // border: 1px solid rgba(220, 220, 220, 0.5);
        position: absolute;
        right: 40px;
        bottom: 68px;
        z-index: 999;
        color: #93A4BC;
        padding: 0;
        cursor: pointer;
    }

    .dot {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 3px;
        margin-right: 8px;
    }

    /deep/ .selection-column .cell {
        padding-left: 12px !important;
    }

}

.el-table {
    width: 100%;

    /deep/ .el-table__row td:nth-last-of-type(1) .cell,
    /deep/ thead th:nth-last-of-type(1) .cell {
        padding-left: 14px !important;
    }

    // /deep/ .cell {
    //     padding-left: 14px !important;
    //     padding-right: 10px !important;
    //     // padding: 0 !important;
    // }

    /deep/ .el-table__cell {
        height: 46px;
        padding: 0 !important;
    }

    /deep/ .el-table__fixed,
    /deep/ .el-table__fixed-right {
        // box-shadow: -2px 0px 2px 0px rgba(0, 0, 0, 0.1);
        box-shadow: none;
        height: 0;
    }

    /deep/ .el-table__body-wrapper.is-scrolling-right~.el-table__fixed-right {
        box-shadow: none;
    }

    .el-button--text {
        font-size: 14px;
        font-weight: 400;
        color: #165DFF;
        padding: 0;

        &.grey {
            color: #86909C;
        }

        &:hover {
            opacity: .7;
        }

        &.danger {
            color: #EC5B56;
        }

    }

    .el-button+.el-button {
        margin-left: 11px;
    }
}
</style>



<style lang="scss" scoped>
.el-submenu.is-active .el-submenu__title {
    border-left: 3px solid #3296fa;
}

.signImage {
    width: 100%;
    display: block;
}

.signTitle {
    margin-top: 10px;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    p {
        margin-bottom: 10px;
    }
}
</style>
